import { PayloadAction } from "@reduxjs/toolkit";
import { createApi, createSlice } from "utils/@reduxjs/toolkit";
import { useInjectReducer } from "utils/redux-injectors";
import { ForgotPasswordState } from "./types";
import { endpoints, baseQuery, formatErrors } from "utils/api/endpoints";

export const initialState: ForgotPasswordState = {};

const slice = createSlice({
  name: "forgotPassword",
  initialState,
  reducers: {
    someAction(state, action: PayloadAction<any>) {},
  },
});

export const api = createApi({
  reducerPath: "forgotPasswordApi",
  baseQuery,
  endpoints: (builder) => ({
    forgotPasswordSendOtp:builder.mutation({
      query:(body) => {
        return {
          ...endpoints.forgotPassword,
          body,
        }
      },
      transformErrorResponse(baseQueryReturnValue, meta, arg) {
				return formatErrors(baseQueryReturnValue.data);
			},
    }),
    verifyResetPasswordOtp:builder.mutation({
      query:(body) => {
        return {
          ...endpoints.verifyResetPasswordOtp,
          body,
        }
      },
      transformErrorResponse(baseQueryReturnValue, meta, arg) {
				return formatErrors(baseQueryReturnValue.data);
			},
    }),
    resetPassword: builder.mutation({
      query: (body) => {
        return {
          ...endpoints.resetPassword,
          body,
        }
      },
      transformErrorResponse(baseQueryReturnValue, meta, arg) {
        return formatErrors(baseQueryReturnValue.data);
      },
    })
  })
})
export const { actions: Actions } = slice;

export const useSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectReducer({ key: api.reducerPath, reducer: api.reducer });
  return { actions: slice.actions, ...api };
};

/**
 * Example Usage:
 *
 * export function MyComponentNeedingThisSlice() {
 *  const { actions } = useSlice();
 *
 *  const onButtonClick = (evt) => {
 *    dispatch(actions.someAction());
 *   };
 * }
 */
